import React, { useState, useEffect, Fragment, useReducer } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import '../sass/app.scss';
import '../components/loading/loading.scss';
// import '../components/my-eir-dashboard/rtm.scss';
import { useAppStyle } from './useAppStyles';
import MyEirLogout from '../components/my-eir-logout/MyEirLogout';
import MyEirTopUp from '../components/my-eir-topup/MyEirTopUp';
import MyEirDashboardConatiner from '../components/my-eir-dashboard/MyEirDashboardContainer';
import MyEirProfileContainer from '../components/my-eir-profile/MyEirProfileContainer';
import MyEirUsageContainer from '../components/my-eir-usage/MyEirUsageContainer';
import MyEirAddonContainer from '../components/my-eir-addons/MyEirAddonContainer';
import PrepayApp from '../components/PrepayApp';
import MobileApp from '../mobilecomponents/MobileApp';
import Session from '../components/shared/Session';
import useGTMPageView from '../hooks/useGTMPageView';
import HeaderContainer from './HeaderContainer';
import FooterContainer from './FooterContainer';
import MyEirEmailConfirmationModal from './MyEirPostpayRegistration/MyEirEmailConfirmationModal';
import MyEirCreatePassword from './MyEirPostpayRegistration/MyEirCreatePassword';
import MyEirAlreadyRegistered from './MyEirPostpayRegistration/MyEirAlreadyRegistered';
import MyEirDOB from './MyEirPostpayRegistration/MyEirDOB';
import MyEirEnterAccountNumber from './MyEirPostpayRegistration/MyEirEnterAccountNumber';
import MyEirPhoneNumber from './MyEirPostpayRegistration/MyEirPhoneNumber';
import MyEirRegisterEmail from './MyEirPostpayRegistration/MyEirRegisterEmail';
import MyEirVerificationCode from './MyEirPostpayRegistration/MyEirVerificationCode';
import MyEirForgotPasswordForm from './my-eir-forgotPassword/MyEirForgotPasswordForm';
import BillDetails from '../mobilecomponents/bill-details/BillDetails';
// import PaymentMethod from '../mobilecomponents/payment-flow/PaymentMethod';
import RegisterContainer from './MyEirPostpayRegistration/RegisterContainer';
import { ESIM_STATUS, MY_EIR_CONST } from '../components/myeirconstant/myEirConstant';
import ResetPasswordContainer from './MyEirPostpayRegistration/ResetPasswordContainer';
import MyEirCreatePasswordForm from './my-eir-createPassword/MyEirCreatePasswordForm';
import PasswordContainer from './MyEirPostpayRegistration/PasswordContainer';
import MyEirAccountContainer from '../mobilecomponents/my-account/MyEirAccountContainer';
import MyEirCreatePasswordFormPage from './my-eir-createPassword/MyEirCreatePasswordFormPage';
import MyEirRegisterForm from '../components/my-eir-register/MyEirRegisterForm';
import PaymentFlowModal from '../mobilecomponents/payment-flow/PaymentFlowModal';
import PaymentStatusModal from '../mobilecomponents/payment-flow/PaymentStatusModal';
import ForgotUsernameContainer from './MyEirPostpayRegistration/ForgotUsernameContainer';
import MyBalance from '../mobilecomponents/my-balance/MyBalance';
import PaymentAddCard from '../mobilecomponents/payment-flow/PaymentAddCard';
import AmazonPrimeVideo from '../mobilecomponents/eir-amazon-prime-video/AmazonPrimeVideo';
import DeviceManagement from '../mobilecomponents/my-plan/manage-my-device/DeviceManagement';
import MyEirBalanceContainer from '../mobilecomponents/redesign-5.2/my-balance/MyEirBalanceContainer';
import MyEirNavigationBarContainer from '../mobilecomponents/redesign-5.2/navigation-bar/MyEirNavigationBarContainer';
import SimReplacement from '../mobilecomponents/redesign-5.2/SimReplacement';
import MobileHeaderRedesign from '../mobilecomponents/redesign-5.2/MobileHeaderRedesign';
import MyPreferences from '../../src/mobilecomponents/redesign-5.2/preferences/MyPreferences';
import RedesignApp from '../mobilecomponents/redesign-5.2/RedesignApp';
import MyAccountDetails from '../../src/mobilecomponents/redesign-5.2/account-details/MyAccountDetails';
import MyEirContracts from '../mobilecomponents/redesign-5.2/contract-details/MyEirContracts';
import AccountSimreplacement from '../mobilecomponents/redesign-5.2/sim-replacement/AccountSimreplacement';
import MyEirServicesContainer from '../mobilecomponents/redesign-5.2/my-services/MyEirServicesContainer';
import MyEirOnboardingContainer from '../mobilecomponents/redesign-5.2/onboarding-screens/MyEirOnboardingContainer';
import MyEirBillContainer from '../../src/mobilecomponents/redesign-5.2/my-bills/MyEirBillContainer';
import MyEirMyPaymentsNew from '../../src/mobilecomponents/redesign-5.2/my-payment/MyEirMyPaymentsNew';
import FAQ from '../mobilecomponents/FAQ';
import ActiveAddonsContainer from '../mobilecomponents/redesign-5.2/manage-my-addons/ActiveAddonsContainer';
import RecomendedOffersContainer from '../mobilecomponents/redesign-5.2/recomended-offers/RecomendedOffersContainer';
import { initialState, redesignReducer, RedesignContext } from '../global-context-redesign';
import MyEirOfferDetail from '../mobilecomponents/redesign-5.2/offer-details/MyEirOfferDetail';
import NoticeOfMultipleAccount from '../mobilecomponents/my-login/NoticeOfMultipleAccount';
import LoginContainer from '../mobilecomponents/my-login/LoginContainer';
import ESIMActivationTile from '../mobilecomponents/redesign-5.2/my-services/eSIMActivationTile';
import HelpAndSupportContainer from '../mobilecomponents/redesign-5.2/help-and-support/HelpAndSupportContainer';
import {
    authenticateBiometricCredentials,
    getDataFromEirAppDB,
    updateDataToEirAppDB,
} from '../mobilecomponents/redesign-5.2/biometrics/biometrics.util';
import { useApolloClient } from '@apollo/client';
import {
    getTokenFromCookies,
    setCookie,
    setTokenInCookies,
    triggerAdobeApi,
} from '../mobilecomponents/redesign-5.2/redesign.api';
import {
    getAccountType,
    getFeature,
    getLatestAppVersionApi,
    sendMfaOtp,
} from '../mobilecomponents/my-login/loginOperation.api';
import {
    isUpdateAvailable,
    setSessionStorageValues,
} from '../mobilecomponents/my-login/loginOperation.util';
import { getNameAndAccountID } from '../mobilecomponents/getNameAndAccountNumber';
import { TrainRounded } from '@material-ui/icons';
import Loading from '../components/loading/Loading';
import { CircularProgress } from '@material-ui/core';
import { getServiceId } from '../mobilecomponents/getServiceID';
import { publish, subscribe } from 'pubsub-js';
import { getServiceForSubscription } from '../mobilecomponents/redesign-5.2/sim-replacement/simReplacement.util';
import LatestAppInfoPopup from '../mobilecomponents/my-login/LatestAppInfoPopup';

function App() {
    const [loginSuccess, setLoginsuccess] = useState(
        JSON.parse(sessionStorage.getItem('loginSuccess')) == true ? true : false
    );
    const [loginScreen, setLoginScreen] = useState(false);
    const [state, dispatch] = useReducer(redesignReducer, initialState);
    // const [token, setToken] = useState();
    const history = useHistory();
    // const [path, setPath] = useState(window.location.pathname);
    const isR6Account = sessionStorage.getItem('hasR6');
    const [hasR6Acc, setHasR6Acc] = useState(false);
    const [showESIMActivationTile, setshowESIMActivationTile] = useState(false);
    const [showManagesim, setshowManagesim] = useState(null);
    const [userCredential, setUserCredential] = useState(null);
    const [otpUUID, setOtpUUID] = useState('');
    const [delivery, setDelivery] = useState('');
    const [mfa, setMFA] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [invalidText, setInvalidText] = useState(false);
    const graphql = useApolloClient();

    const classes = useAppStyle();
    const userFeatures = JSON.parse(sessionStorage.getItem('LoggedinUserFeatures') || '[]');

    //Version checker for iOS devices

    const [showUpdatePopup, setShowUpdatePopup] = useState(false);
    const token = getTokenFromCookies();

    const togglePopup = () => {
        setShowUpdatePopup(!showUpdatePopup);
    };

    const loadDashboard = async ({ data, userCredential }) => {
        if (
            data?.data?.biometricsLogin.accessToken != undefined ||
            data?.data?.biometricsLogin.refreshToken != undefined
        ) {
            const token = data.data.biometricsLogin.accessToken;

            setTokenInCookies(token, new Date().getTime() + 60 * 60 * 1000);
            updateDataToEirAppDB({
                offlineToken: data?.data?.biometricsLogin.refreshToken,
            });

            if (data.data.biometricsLogin.mfaToken != undefined) {
                // Device is trusted
                if (token.startsWith('ey')) {
                    setCookie('MFA', 'TOKEN', data.data.biometricsLogin.mfaToken);

                    sessionStorage.setItem('LoggedinUser', userCredential?.user);
                    setCookie('ION', 'EMAIL_ADDRESS', userCredential?.user);
                    sessionStorage.setItem('LoggedinUserBrand', 'ion');
                    sessionStorage.setItem('hasION', data.data.biometricsLogin.isION);
                    sessionStorage.setItem('hasR6', data.data.biometricsLogin.isR6);
                    sessionStorage.setItem('access_token', data.data.biometricsLogin.accessToken);
                    sessionStorage.setItem('R6_status_code', data.data.biometricsLogin.statusCode);
                    sessionStorage.setItem(
                        'R6_passwordResetToken',
                        data.data.biometricsLogin.passwordResetToken
                    );
                    sessionStorage.setItem(
                        'R6_numberOfAuthenticationAttemptsRemaining',
                        data.data.biometricsLogin.numberOfAuthenticationAttemptsRemaining
                    );

                    /* Required data for redirection from my-eir to eir.ie*/

                    const refreshToken = data.data.biometricsLogin.refreshToken;
                    setCookie('ION', 'refresh_Token', refreshToken);
                    sessionStorage.setItem('refresh_token', refreshToken);
                    const type = await getAccountType({ graphql });
                    const featureList = await getFeature({
                        graphql,
                        username: userCredential.user,
                    });
                    sessionStorage.setItem(
                        'LoggedinUserFeatures',
                        JSON.stringify(featureList?.features)
                    );
                    const accessTokenExpiresIn =
                        data.data.biometricsLogin.accessTokenExpiresIn * 1000;
                    const sessionExpiryTime = new Date(
                        new Date().getTime() + accessTokenExpiresIn
                    ).getTime();
                    sessionStorage.setItem(
                        'myEirSession',
                        JSON.stringify({
                            sessionExpiryTime,
                            accessTokenExpiresIn,
                        })
                    );

                    if (type.accountType.prepay && type.accountType.postpay) {
                        setIsLoading(false);
                        setLoginScreen(true);

                        window.location.href = `/`;
                    } else if (type.accountType.prepay && !type.accountType.postpay) {
                        sessionStorage.setItem('LoggedinUserBillType', 'Prepay');
                        setIsLoading(false);
                        window.location.href = `/prepay/dashboard`;
                    } else if (type.accountType.postpay && !type.accountType.prepay) {
                        sessionStorage.setItem('LoggedinUserBillType', 'Bill');

                        console.log('call analytcs......');
                        const response2 = await getNameAndAccountID(graphql);
                        const serviceResponse = await getServiceId(graphql);

                        await triggerAdobeApi({ graphql, name: 'login' });
                        sessionStorage.setItem('Biometrics_opted_in', true);
                        setIsLoading(false);
                        window.location.href = `/account/dashboard`;
                    }
                } else if (token.startsWith('AQI')) {
                    // window.location.href = '/bundles/login?email=' + enteredName;
                    setIsLoading(false);
                    window.location.href = `/prepay/dashboard`;
                } else if (type.accountType.postpay && !type.accountType.prepay) {
                    sessionStorage.setItem('LoggedinUserBillType', 'Bill');

                    console.log('call analytcs......');
                    const response2 = await getNameAndAccountID(graphql);
                    const serviceResponse = await getServiceId(graphql);

                    await triggerAdobeApi({ graphql, name: 'login' });
                    sessionStorage.setItem('Biometrics_opted_in', true);
                    sessionStorage.setItem('MFA_FORCED', data.data.biometricsLogin.mfaForced);
                    setIsLoading(false);
                    window.location.href = `/account/dashboard`;
                }
            } else if (token.startsWith('AQI')) {
                // window.location.href = '/bundles/login?email=' + enteredName;
                setIsLoading(false);
                const baseUrl = '/bundles/login?email=' + userCredential.user;
                const isIonValue = data.data.biometricsLogin.isION;
                const token = data.data.biometricsLogin.accessToken;

                const contextVal = {
                    isIon: isIonValue,
                    token: token,
                    isNoticeClicked: false,
                };

                const context = encodeURIComponent(JSON.stringify(contextVal));
                window.location.href = `${baseUrl}&context=${context}`;
            }
            sessionStorage.setItem('loginSuccess', true);
        }
    };

    // Function to send the Apple Auth login message
    const appleAuthLogin = () => {
        if (window.webkit?.messageHandlers?.appleAuthLogin) {
            window.webkit.messageHandlers.appleAuthLogin.postMessage({});
        }
    };

    // Handle callback from iOS
    const handleAppleAuthResult = async e => {
        try {
            setIsLoading(true);
            console.log('Event received:', e);
            const detail = e?.detail;
            if (detail?.status === 'success') {
                const userCredential = await getDataFromEirAppDB('user_credential');
                const data = await authenticateBiometricCredentials({
                    graphql,
                    offlineToken: userCredential?.offlineToken,
                    deviceId: userCredential?.deviceId,
                    biometricsProvider: userCredential?.biometricsProvider,
                    appleIdentifier: detail?.appleIdentifier,
                });
                window.removeEventListener('appleAuthLoginResult', handleAppleAuthResult);
                if (data) {
                    await loadDashboard({ data, userCredential });
                }
                setIsLoading(false);
            } else {
                setIsLoading(false);
                console.warn('Apple Auth failed or detail missing:', detail);
            }
        } catch (error) {
            setIsLoading(false);
            console.log('biometrics login error:', error);
            alert('Failed to authenticate biometrics!');
            if (error.message.includes('password changed')) setInvalidText(true);
        }
    };

    const handleBiometricsLogin = async ({ userCredential }) => {
        try {
            setIsLoading(true);
            let data;
            if (
                userCredential?.biometricsProvider &&
                userCredential?.biometricsProvider === 'APPLE'
            ) {
                appleAuthLogin();
            } else if (
                userCredential?.biometricsProvider === 'WEBAUTHN' &&
                userCredential?.credentialId
            ) {
                data = await authenticateBiometricCredentials({
                    graphql,
                    offlineToken: userCredential?.offlineToken,
                    deviceId: userCredential?.deviceId,
                    biometricsProvider: userCredential?.biometricsProvider,
                    credentialId: userCredential?.credentialId,
                });
                //load dashboard
                if (data) {
                    await loadDashboard({ data, userCredential });
                }
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log('biometrics login error:', error);
            alert('Failed to authenticate biometrics!');

            if (error.message.includes('password changed')) setInvalidText(true);
        }
    };
    const handleResetPassword = async () => {
        const queryParam = new URLSearchParams(window.location.search);
        // execution value only for R6 and for ION username value from url

        const contactUUIDIon = queryParam.get('username');
        const token = queryParam.get('token');
        const data = await sendMfaOtp({
            graphql,
            // username: 'c90dd3a9-0bd8-40ae-8062-1b6da5a74bef',
            username: contactUUIDIon ?? undefined,
            operation: 'CHANGE_PASSWORD',
        });

        setMFA(data.sendMFAOTP.mfaForced || false);

        setOtpUUID(data.sendMFAOTP.uuid);
        setDelivery(data.sendMFAOTP.deliveryMethod);
        setTokenInCookies(token, new Date().getTime() + 60 * 60 * 1000);
    };

    useEffect(() => {
        const data = JSON.parse(sessionStorage.getItem('LoggedinServices'));
        if (data) {
            const services = data.filter(
                service =>
                    service.simCardType === 'ESIM' &&
                    ![...ESIM_STATUS, null].includes(service.esimStatus?.toUpperCase() ?? null)
            );
            setshowESIMActivationTile(services?.length > 0);
            setshowManagesim(services);
        }
    }, []);

    useEffect(() => {
        const billType = sessionStorage.getItem('LoggedinUserBillType');
        const pathname = window.location.pathname;

        // setPath(pathname);
        if (billType == 'Prepay') {
            pathname.indexOf('/account') == 0 && history.push('/prepay/dashboard');

            pathname == '/' && history.push('/prepay/dashboard');
        }
        if (billType == 'Bill') {
            pathname.indexOf('/prepay') == 0 && history.push('/prepay/dashboard');

            pathname == '/' && history.push('/account/dashboard');
            // pathname == '/' && history.push('/account/redesign-dashboard');
        }

        if (billType == 'Fixed_Bill') {
            (pathname.indexOf('/prepay') == 0 || pathname.indexOf('/account') == 0) &&
                (window.location.href = location.origin);
            loginSuccess && pathname == '/' && (window.location.href = '/bundles/dashboard');
        }
        if (pathname.indexOf('/create-password') > -1) {
            handleResetPassword();
        }
    }, [window.location.pathname]);

    useEffect(() => {
        setHasR6Acc(isR6Account);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const badge = document.querySelector('.grecaptcha-badge');

            if (badge) {
                badge.style.zIndex = '9999';
                badge.style.setProperty('bottom', '84px', 'important');

                badge.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (badge.style.transform === 'translateY(0px)') {
                        badge.style.transform = 'translateY(60px)';
                    } else {
                        badge.style.transform = 'translateY(0px)';
                    }
                });
                clearInterval(interval);
            }
        }, 100);
    }, []);

    // onload biometrics enrollment check & version update check
    useEffect(() => {
        const fetchUpdate = async () => {
            try {
                const userAgent = window.navigator.userAgent.toLowerCase();
                const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
                const isInStandaloneMode = () =>
                    'standalone' in window.navigator && window.navigator.standalone;

                if (isIOSDevice && isInStandaloneMode()) {
                    const { version = '', build = '' } = window?.iOSAppInfo || {};
                    const currentVersion = build ? `${version}.${build}` : '0.0.0'; // Incase the current version is not detectable then use default value to get isUpdateRequired as true
                    const data = await getLatestAppVersionApi({ graphql });
                    const { latestVersion, recentVersions } = data?.latestAppVersion;

                    const isUpdateRequired = isUpdateAvailable({
                        currentVersion,
                        latestVersion,
                        recentVersions,
                    });
                    if (isUpdateRequired) {
                        setShowUpdatePopup(isUpdateRequired);
                    }
                }
            } catch (error) {
                console.error('error checking versions:', error);
                setShowUpdatePopup(false);
            }
        };

        const fetchDataFromEirAppDB = async () => {
            const value = await getDataFromEirAppDB('user_credential');
            setUserCredential(value);
        };
        const runSequence = async () => {
            await fetchUpdate();
            await fetchDataFromEirAppDB();
        };
        runSequence();
        // Add listener BEFORE sending message
        window.addEventListener('appleAuthLoginResult', handleAppleAuthResult);
    }, []);
    useEffect(() => {
        const triggerBiometrics = () => {
            const iOSstandaloneMode = window.navigator.standalone;
            const androidPwaMode = window.matchMedia('(display-mode:standalone)').matches;
            let accessTokenValue = sessionStorage.getItem('access_token');

            return (
                (iOSstandaloneMode || androidPwaMode) &&
                userCredential?.offlineToken &&
                userCredential?.deviceId &&
                (userCredential?.credentialId ||
                    (userCredential?.biometricsProvider &&
                        userCredential?.biometricsProvider === 'APPLE')) &&
                !accessTokenValue
            );
        };

        if (triggerBiometrics()) {
            handleBiometricsLogin({ userCredential });
        }
    }, [userCredential]);
    const dashboardeSIMActivate = async () => {
        console.log('Refresh Dashboard eSIM Activation Tile');
        const data = JSON.parse(sessionStorage.getItem('LoggedinServices'));
        if (data) {
            const services = data.filter(
                data =>
                    data.simCardType === 'ESIM' &&
                    ![...ESIM_STATUS, null].includes(data.esimStatus?.toUpperCase() ?? null)
            );
            setshowESIMActivationTile(services?.length > 0);
            setshowManagesim(services);
        }
    };
    useEffect(() => {
        dashboardeSIMActivate();
    }, []);

    subscribe('RELOAD_DASHBOARD_ESIMACTIVATION', dashboardeSIMActivate);

    useGTMPageView();
    return (
        <div>
            {loginSuccess && <Session />}
            <RedesignContext.Provider value={{ state, dispatch }}>
                <Switch>
                    <Route exact path='/'>
                        <div id='my-eir-mobile' className='myeir-mobile-background'>
                            <HeaderContainer appname={'mobile'} loginSuccess={loginSuccess} />
                            <div className={isLoading ? classes.body : ''}>
                                {isLoading && (
                                    <div className={classes.boxx}>
                                        <h2 className={classes.greeting}>Hi there</h2>
                                        <h3 className={classes.wereloading}>
                                            We're loading your account
                                        </h3>
                                        <div className={classes.loader}>
                                            <CircularProgress
                                                disableShrink
                                                style={{
                                                    color: '#493553',
                                                    width: '34px',
                                                    height: '40px',
                                                    // marginRight: '5px',
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {showUpdatePopup ? (
                                <LatestAppInfoPopup open={showUpdatePopup} setOpen={togglePopup} />
                            ) : (
                                ''
                            )}
                            <LoginContainer
                                screen={loginScreen ? 1 : 0}
                                flag={invalidText ? 'passwordChanged' : ''}
                            />
                            <FooterContainer appname={'mobile'} />
                        </div>
                    </Route>
                    <Route exact path='/register'>
                        <div
                            id='my-eir-mobile'
                            className='myeir-mobile-background myeir-background-large '
                        >
                            <HeaderContainer appname={'mobile'} loginSuccess={loginSuccess} />
                            <RegisterContainer />
                            <FooterContainer appname={'mobile'} />
                        </div>
                    </Route>
                    <Route exact path='/forgot-email'>
                        <div
                            id='my-eir-mobile'
                            className='myeir-mobile-background myeir-background-large'
                        >
                            <HeaderContainer appname={'mobile'} loginSuccess={loginSuccess} />
                            <ForgotUsernameContainer />
                            <FooterContainer appname={'mobile'} />
                        </div>
                    </Route>

                    <Route exact path='/forgot-password'>
                        <div id='my-eir-mobile' className='myeir-mobile-background'>
                            <HeaderContainer appname={'mobile'} loginSuccess={loginSuccess} />
                            <ResetPasswordContainer />
                            <FooterContainer appname={'mobile'} />
                        </div>
                    </Route>
                    <Route exact path='/create-password'>
                        <div id='my-eir-mobile' className='myeir-mobile-background'>
                            <HeaderContainer appname={'mobile'} loginSuccess={loginSuccess} />
                            {mfa != undefined && (
                                <PasswordContainer
                                    otpUuid={otpUUID}
                                    username={userCredential?.user}
                                    delivery={delivery}
                                    mfa={mfa}
                                />
                            )}
                            <FooterContainer appname={'mobile'} />
                        </div>
                    </Route>
                    {/* <Route exact path='/mobile/test'>
                    <MobileApp loginSuccess={loginSuccess}>
                        <div style={{ background: '#FFFFFF' }}>
                            TV
                            <AmazonPrimeVideo apvCustomerType='TV' />
                            Broadband
                            <AmazonPrimeVideo apvCustomerType='Broadband' />
                            DeviceManagement
                            <DeviceManagement />
                        </div>
                    </MobileApp>
                </Route>
                <Route exact path='/mobile/test/payment'>
                    <MobileApp loginSuccess={loginSuccess}>
                        <PaymentFlowModal
                            open={true}
                            toggle={console.log(true)}
                            amount={1.2}
                            buttonRequired={false}
                        />
                    </MobileApp>
                </Route>*/}
                    {loginSuccess ? (
                        <Fragment>
                            <Route exact path='/prepay/dashboard'>
                                <PrepayApp>
                                    <MyEirDashboardConatiner />
                                </PrepayApp>
                            </Route>
                            <Route exact path='/prepay/topup'>
                                <PrepayApp>
                                    <MyEirTopUp />
                                </PrepayApp>
                            </Route>
                            <Route exact path='/prepay/logout'>
                                <PrepayApp>
                                    <MyEirLogout />
                                </PrepayApp>
                            </Route>
                            <Route exact path='/prepay/profile'>
                                <PrepayApp>
                                    <MyEirProfileContainer />
                                </PrepayApp>
                            </Route>
                            <Route exact path='/prepay/my-usage'>
                                <PrepayApp>
                                    <MyEirUsageContainer />
                                </PrepayApp>
                            </Route>
                            <Route exact path='/prepay/my-addons'>
                                <PrepayApp>
                                    <MyEirAddonContainer />
                                </PrepayApp>
                            </Route>
                            {/* eSIM Feature */}
                            <Route exact path='/prepay/manage-sim'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <AccountSimreplacement />
                                </RedesignApp>
                            </Route>
                            {/* <Route exact path='/account/dashboard'>
                            <MobileApp loginSuccess={loginSuccess} />
                        </Route> */}
                            <Route exact path='/account/dashboard'>
                                {/* <MobileApp loginSuccess={loginSuccess} /> */}
                                <RedesignApp loginSuccess={loginSuccess} offsetBackgroundImage>
                                    <MyEirOnboardingContainer />
                                    {hasR6Acc === 'true' && <NoticeOfMultipleAccount />}
                                    {/* Enable eSIM Feature */}
                                    {userFeatures?.filter(
                                        feature => feature?.feature_name === 'esim'
                                    ).length > 0 &&
                                        showESIMActivationTile && (
                                            <ESIMActivationTile services={showManagesim} />
                                        )}
                                    <MyEirBalanceContainer />

                                    <MyEirServicesContainer />
                                    <ActiveAddonsContainer />
                                    <RecomendedOffersContainer />
                                    <FAQ />

                                    <MyEirNavigationBarContainer />
                                </RedesignApp>
                            </Route>
                            {/* <Route exact path='/account/redesign-dashboard'>
                            <RedesignApp loginSuccess={loginSuccess} offsetBackgroundImage>
                                <MyEirBalanceContainer />

                                <MyEirServicesContainer />

                                <MyEirNavigationBarContainer />
                            </RedesignApp>
                        </Route> */}
                            <Route exact path='/account/details'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <MyAccountDetails />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/offers'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <MyEirOfferDetail />
                                    {/* commeted the below component for testers to test offerPage in prod mobile view/ */}
                                    <MyEirNavigationBarContainer />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/simreplacement'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <AccountSimreplacement />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/manage-sim'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <AccountSimreplacement />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/contracts'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <MyEirContracts />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/preferences'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <MyPreferences />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/bills'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <MyEirBillContainer />
                                    <MyEirNavigationBarContainer />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/account/payments'>
                                <RedesignApp loginSuccess={loginSuccess} offsetBackgroundImage>
                                    <MyEirMyPaymentsNew />
                                    <MyEirNavigationBarContainer />
                                </RedesignApp>
                            </Route>
                            <Route exact path='/help'>
                                <RedesignApp loginSuccess={loginSuccess}>
                                    <HelpAndSupportContainer />
                                    <FAQ />
                                    <MyEirNavigationBarContainer />
                                </RedesignApp>
                            </Route>
                        </Fragment>
                    ) : (
                        <Redirect to={{ pathname: '/' }} />
                    )}
                    <Route>
                        {/* this is used for 404. */}
                        <Redirect to={{ pathname: '/' }} />
                    </Route>
                </Switch>
            </RedesignContext.Provider>
        </div>
    );
}

export default App;
